export const URL_SEARCH_PARAMS = {
  fromBlockchain: 'fromBlockchain',
  fromToken: 'fromToken',
} as const;

export const WIDGET_BASE_ROUTE = '/bridge';
